export function getMarketingSiteUrl(): string {
  const { hostname } = window.location;
  const configured = import.meta.env.VITE_SITE_URL as string | undefined;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return configured?.replace(/\/$/, '') || 'http://localhost:4321';
  }

  if (hostname.includes('staging')) {
    return 'https://staging.merchmuse.art';
  }

  if (hostname === 'merchmuse.art' || hostname === 'app.merchmuse.art') {
    return 'https://merchmuse.art';
  }

  if (configured) {
    return configured.replace(/\/$/, '');
  }

  return 'https://merchmuse.art';
}
